export const PATH_SEPARATOR = '/';
export const PATH_ROOT = PATH_SEPARATOR;
export const PATH_SEPARATOR_ENDING_REGEX = new RegExp(`${PATH_SEPARATOR}+$`);
export const PATH_SEPARATOR_LEADING_REGEX = new RegExp(`^${PATH_SEPARATOR}+`);
